<script>
import AImage from "@components/atoms/a-image.vue";
import AButton from "@components/atoms/a-button.vue";
export default {
  name: "OFooter",
  components: {
    AImage,
    AButton,
  },
  props: {
    imageSecurity: {
      type: Object,
      default: () => ({
        images: [
          {
            name: "Site Seguro",
            url: "/img/ssl.svg",
          },
          {
            name: "Google Site Seguro",
            url: "/img/google-site-seguro.svg",
          },
          {
            name: "Site 100% Seguro",
            url: "/img/site-seguro.svg",
          },
        ],
      }),
    },
  },
  methods: {
    handleSubmit() {
      this.$store.dispatch("forms/startSubmit", this.$route.name);
    },
  },
};
</script>

<template lang="pug">
  footer(class="flex justify-between items-center flex-col px-4 md:flex-row-reverse")
    AButton(success class="mb-6 md:mb-0" @click="handleSubmit" ref="buttonSubmit") {{$route.name === "Pagamento" ? "Finalizar" : $route.name === "ComplementarDados" ? "Confirmar" : "Avançar" }}
    AImage(:paths="imageSecurity.images" class="flex items-center justify-center" classList="mx-2 w-20 md:h-7 md:w-32")
</template>
